{
  "name": "@ns/support-companies-house-failing",
  "version": "1.0.0",
  "description": "A company's Companies House check has failed every attempt for at least 12 hours: find out why, re-check it, then mark it resolved",
  "inputs": {
    "subjectCompanyId": {
      "type": "string"
    },
    "subjectCompanyName": {
      "type": "string"
    },
    "failingSince": {
      "type": "string"
    },
    "failingReason": {
      "type": "string"
    },
    "failedAttempts": {
      "type": "string"
    }
  },
  "outcomes": {
    "resolved": {}
  }
}
